module.exports = __webpack_public_path__ + "static/media/github.1f33e75d.svg";